export interface BaseModuleSubtypeResponse {
    subtype: Subtype;
    id: number;
    isRequiredForCompletionByEmployee: boolean;
    isRequiredForCompletionByCompanyManagement: boolean;
    order: number;
    name: string | null;
};

export enum Subtype {
    AnniversaryBonusModuleSubtype = "AnniversaryBonusModuleSubtype",
    BirthdayBonusModuleSubtype = "BirthdayBonusModuleSubtype",
    ChecklistAnswerModuleSubtype = "ChecklistAnswerModuleSubtype",
    EvaluationStarsModuleSubtype = "EvaluationStarsModuleSubtype",
    EvaluationThumbsModuleSubtype = "EvaluationThumbsModuleSubtype",
    MultiPictureUploadModuleSubtype = "MultiPictureUploadModuleSubtype",
    PictureUploadModuleSubtype = "PictureUploadModuleSubtype",
    PresenceQuotaModuleSubtype = "PresenceQuotaModuleSubtype",
    SignatureControlModuleSubtype = "SignatureControlModuleSubtype",
    TextAnswerModuleSubtype = "TextAnswerModuleSubtype",
    WelcomeBonisoftModuleSubtype = "WelcomeBonisoftModuleSubtype",
    SurveyAppointmentModuleSubtype = "SurveyAppointmentModuleSubtype"
};
